import { Component, OnDestroy, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';
import * as authActions from '@auth/store/auth.actions';
import { DataService } from '@data/data.service';

import * as gridColumnDefinitions from '../change-customer-grid/change-customer-grid.columns';

@Component({
  selector: 'app-change-customer-screen',
  templateUrl: './change-customer-screen.component.html',
  styleUrls: ['./change-customer-screen.component.scss'],
})
export class ChangeCustomerScreenComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  private prevScreenOffset: number;

  public showGrid = false;
  public selectedRow: any = null;

  public menuList = [
    { action: () => this.dismissDialog(), icon: 'cancel', title: 'Close' },
    { action: () => this.authService.changeCustomerShowing.next('filter'), icon: 'filter_alt' },
    { action: () => this.selectRow(), icon: 'check_box', title: 'Select', condition: () => !!this.selectedRow },
    { action: () => this.authService.changeCustomerShowing.next('help'), icon: 'help_outline', title: 'Help' },
  ];

  public helpList = [
    { icon: 'cancel', title: 'Dismiss Dialog' },
    { icon: 'filter_alt', title: 'Filter' },
    { icon: 'check_box', title: 'Select Customer' },
  ];

  public columns = gridColumnDefinitions;
  public changeScreen = (area) => this.authService.changeCustomerShowing.next(area);
  public showMain = () => this.authService.changeCustomerShowing.next('grid');

  constructor(public authService: AuthService, private store: Store, public dataService: DataService) {}

  ngOnInit() {
    this.authService.selectedCustomerRow$.pipe(takeUntil(this.destroy$)).subscribe((row) => (this.selectedRow = row));

    this.authService.changeCustomerDialog$
      .pipe(
        filter((x) => !!x),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.init());

    this.authService.changeCustomerDismissDialog.next(false);
    this.authService.changeCustomerDismissDialog.pipe(takeUntil(this.destroy$)).subscribe((x) => {
      if (x) {
        this.dismissDialog();
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  init() {
    this.prevScreenOffset = this.dataService.screenOffset;
    this.authService.selectedCustomerRow$.next(null);
    this.dataService.hideScreen$.next(true);

    this.showGrid = false;
    setTimeout(() => (this.showGrid = true), 50);
  }

  dismissDialog() {
    this.dataService.wsScreenAdjust.next(this.prevScreenOffset);
    this.dataService.hideScreen$.next(false);
    this.authService.changeCustomerDialog$.next(false);
    this.authService.changeCustomerDismissDialog.next(false);
  }

  selectRow() {
    if (this.selectedRow) {
      this.authService.changeCustomerOrFacilityPending$.next(true);
      this.store.dispatch(new authActions.ChangeCustomer(this.selectedRow.key));
      this.dismissDialog();
    }
  }
}
